module.exports = __webpack_public_path__ + "static/img/floor1-lz3.8dcad50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-lz3.png
// module id = M9zW
// module chunks = 1